import { Plus } from 'lucide-react'
import { Button } from './ui/button'
import { cn } from '@/lib/utils'

// Icon-only "+" that opens the suggest-an-event dialog, beside Search's field.
export function SuggestIconButton({
  onClick,
  label,
  className,
}: {
  onClick: () => void
  label: string
  className?: string
}) {
  return (
    <Button
      variant="outline"
      size="icon"
      className={cn('shrink-0', className)}
      aria-label={label}
      onClick={onClick}
    >
      <Plus className="size-3.5" />
    </Button>
  )
}
